import React from 'react';
import T from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SensorCard from '../../../components/SensorCard/SensorCard';
import EmptyState from '../../../components/EmptyState';
import { ContainerSensorTitle, SensorsTitle } from './elements';

const Sensor = ({ machine, sensors, hasSensors }) => {
  const { t } = useTranslation();

  const sensorsWithTranslatedNames = (sensors || []).map(item => ({
    ...item
  }));

  return (
    <>
      <ContainerSensorTitle>
        <SensorsTitle>{t('dashboard.sensors.current_status')}</SensorsTitle>
      </ContainerSensorTitle>

      <Grid container spacing={3}>
        {hasSensors ? (
          sensorsWithTranslatedNames.map(sensor => (
            <Grid
              key={sensor.is_custom || sensor.is_static ? sensor.custom_type : sensor.type}
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
            >
              <SensorCard machineId={machine.id} sensor={sensor} />
            </Grid>
          ))
        ) : (
          <EmptyState type="sensors" />
        )}
      </Grid>
    </>
  );
};

Sensor.propTypes = {
  machine: T.shape({
    id: T.string.isRequired
  }).isRequired,
  sensors: T.arrayOf(T.shape({})).isRequired,
  hasSensors: T.bool.isRequired
};

export default Sensor;
